// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__238Oj","largestCol":"styles_largestCol__8o3qk","smallestCol":"styles_smallestCol__2SNod"};